export const DELETE_OPTION = 'DELETE_OPTION';
export const CREATE_UPDATE_OPTION = 'CREATE_UPDATE_OPTION';
export const SAVE_DATA_OPTION_NAME = 'SAVE_DATA_OPTION_NAME';